const DTODAV01 = {
  doQuery: "/api/DTODAV01/doQuery",
  doQueryDep: "/api/DTODAV01/doQueryDep",
  doQueryList: "/api/DTODAV01/doQueryList",
  doQueryReview: "/api/DTODAV01/doQueryReview",
  doInsert: "/api/DTODAV01/doInsert",
  doUpdate: "/api/DTODAV01/doUpdate",
  doDelete: "/api/DTODAV01/doDelete",
  doUpdateActSts: "/api/DTODAV01/doUpdateActSts",
  doUpdateEditSts: "/api/DTODAV01/doUpdateEditSts",
  doQueryAction: "/api/DTODAV01/doQueryAction",
  rootQuery: "/api/DTODAV01/rootQuery",
  rootUpdate: "/api/DTODAV01/rootUpdate",
  doQueryActionByPreview: "/api/DTODAV01/doQueryActionByPreview"
};

export default DTODAV01;
